import AutoComplete from "components/AutoComplete";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import { parseFloatData } from "utils/UtilityFuncs";

let API_URL = "/manufacturer/products/custom-products";
let COMPONENT_URL = "/manufacturer/products";
let COMPONENT_DETAILS_URL = "/manufacturer/products";

let limits = [5, 10, 15, 20];

let filterBy = [
  { name: "All", value: "all" },
  { name: "ID", value: "customProductId" },
  { name: "Style", value: "style" },
  { name: "Custom Description", value: "customDescription" },
  { name: "Custom Packing Description", value: "customPackingDescription" },
  { name: "Custom Price", value: "customPrice" },
];

export default function MCustomProducts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */

  const [customProductsData, setCustomProductsData] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );
  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const handleFilterBy = (filter) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filter);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  //get Data
  const getCustomProductsData = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setCustomProductsData(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // AutoComplete Search Function
  const searchCustomProductsList = async (searchText, fieldName) => {
    try {
      setLoading(true);

      const { data } = await API.post(
        "/manufacturer/products/custom-products/auto-complete",
        { searchText, fieldName },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        return data?.data;
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteCustomProductsData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete(
        "/manufacturer/products/custom-product/" + id,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setCustomProductsData((prev) => prev.filter((item) => item.id !== id));
        await getCustomProductsData();
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const AddCustomProductsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post(
        "/manufacturer/products/custom-product",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setCustomProductsData((prev) => [...prev, data?.data]);
        await getCustomProductsData();
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const UpdateCustomProductsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer/products/custom-product",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setCustomProductsData((prev) => {
        //   const newData = prev.map((item) => {
        //     if (item.id === formData.id) {
        //       return data?.data;
        //     }
        //     return item;
        //   });
        //   return newData;
        // });
        await getCustomProductsData();
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getCustomProductsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary  ms-1"
        >
          Add CustomProduct
        </button>
      </>
    </div>
  );

  const table_head = [
    { name: "ID", value: "customProductId" },
    { name: "Style", value: "style" },
    { name: "Custom Description", value: "customDescription" },
    { name: "Custom Packing Description", value: "customPackingDescription" },
    { name: "Custom Price", value: "customPrice" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td>{item.customProductId}</td>
      <td>{item?.style}</td>
      <td>{item?.customDescription}</td>
      <td>{item?.customPackingDescription}</td>
      <td>{item?.customPrice}</td>

      <td className="table-action">
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn  px-1"}
          deleteFunc={deleteCustomProductsData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ height: "100vh" }}>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div className="px-2">
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end align-items-center gap-1 mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="me-1">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="bg-opacity-10 border border-primary rounded-end rounded-start"
                    >
                      {filterBy.find(
                        (filter) =>
                          filter.value === searchParams.get("filterBy") ||
                          (searchParams.get("filterBy") === null &&
                            filter.value === "all")
                      )?.name || "Filter By"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filterBy.map((filter) => (
                        <Dropdown.Item
                          key={filter.value}
                          onClick={() => handleFilterBy(filter.value)}
                        >
                          {filter.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}${
                  getSearchParamsWithoutGivenKey("query")
                    ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                    : "?"
                }`}
              />
              <div className="">{btn1()}</div>
            </div>

            <div
              className="mb-3"
              style={{ height: "75vh", overflowY: "auto", borderRadius: 15 }}
            >
              {searchResults ? (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={searchResults}
                  totalPages={totalPages}
                />
              ) : (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={customProductsData}
                  totalPages={totalPages}
                />
              )}
            </div>
            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <form
            onSubmit={
              isUpdateMode ? UpdateCustomProductsData : AddCustomProductsData
            }
          >
            <div className="d-flex justify-content-between align-items-center">
              <h4>
                {isUpdateMode ? "Update Custom Product" : "Add Custom Product"}
              </h4>
              {/*   buttons
               ********************************************* */}
              <div className="mb-1">
                <div className="d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setShowAddModal(false);
                    }}
                    className="btn btn-secondary btn-sm"
                    type="button"
                  >
                    Close
                  </button>
                  <button
                    disabled={loading}
                    className="btn btn-primary btn-sm ms-1"
                    type="submit"
                  >
                    {isUpdateMode ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="">
              <div className="mb-3">
                <label className="">Style</label>
                <AutoComplete
                  fieldName={"style"}
                  value={formData?.style || ""}
                  handleChange={(key, value) => {
                    setFormData({ ...formData, [key]: value });
                  }}
                  searchFunction={searchCustomProductsList}
                  placeholder={"Enter Custom Product Name"}
                  required
                  classNames={"form-control"}
                />
              </div>
              <div className="mb-3">
                <label className="">Custom Description</label>
                <div className="">
                  <input
                    type="text"
                    value={formData?.customDescription || ""}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        customDescription: e.target.value,
                      });
                    }}
                    className="form-control"
                    placeholder="Enter 
                  Custom Description"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="">Custom Packing Description</label>
                <div className="">
                  <input
                    type="text"
                    value={formData?.customPackingDescription || ""}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        customPackingDescription: e.target.value,
                      });
                    }}
                    className="form-control"
                    placeholder="Enter Custom Packing Description"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="">Custom Price</label>
                <div className="">
                  <input
                    type="number"
                    step={0.01}
                    min={0}
                    value={formData?.customPrice || ""}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        customPrice: parseFloatData(e.target.value, 2) || "",
                      });
                    }}
                    className="form-control"
                    placeholder="Enter Custom Price"
                  />
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
